import { render, staticRenderFns } from "./trailerInfo.vue?vue&type=template&id=e2b12a12&scoped=true"
import script from "./trailerInfo.vue?vue&type=script&lang=js"
export * from "./trailerInfo.vue?vue&type=script&lang=js"
import style0 from "./trailerInfo.vue?vue&type=style&index=0&id=e2b12a12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b12a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b12a12')) {
      api.createRecord('e2b12a12', component.options)
    } else {
      api.reload('e2b12a12', component.options)
    }
    module.hot.accept("./trailerInfo.vue?vue&type=template&id=e2b12a12&scoped=true", function () {
      api.rerender('e2b12a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mediaManage/mediaContentManage/editDialog_componts/trailerInfo.vue"
export default component.exports